import React, { useEffect, useState } from "react";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import { useLanguageContext } from "../../../Context/LanguageContext";

const AllAttributePanel = (props) => {
  const attributes = props.standardAttributes;
  const [attributeValue, setAttributeValue] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const { localization } = useLanguageContext();

  useEffect(() => {
    setAttributeValue(attributes);
  }, [props.standardAttributes]);

  useEffect(() => {
    if (props.resetFilterFiled) {
      setSearchQuery("");
    }
  }, [props.resetFilterFiled]);

  useEffect(() => {
    if (props.deletedAttribute) {
      if (props.deletedAttribute)
        setAttributeValue((previous) => [
          ...previous,
          {
            nameDisplay: props.deletedAttribute.nameDisplay,
            bezeichnung: props.deletedAttribute.name,
            id: props.deletedAttribute.attributeID,
            isDropdownMenue: props.deletedAttribute.isDropdownMenue,
          },
        ]);
    }
  }, [props.deletedAttribute]);

  /* ....................Handle Selection Of Attribute And Filtering the List Of Attribute....................... */

  function handleSelectedAttribute(selectedAttribute, attributeIndex) {
    props.handleAttributeFunction(selectedAttribute);
    const items1 = attributeValue.filter(
      (element, index) => element.id != selectedAttribute.id
    );
    setAttributeValue(items1);
  }

  return (
    <>
      <div className="container" id="leftpanel">
        <div className="row w-auto mb-1">
          <input
            type="search"
            id="search"
            className="form-control"
            placeholder={localization.search}
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
          />
        </div>
        <div className="row my-custom-scrollbar p-1">
          <ul className="col">
            {attributeValue
              ?.filter((attribute) =>
                attribute.nameDisplay
                  .toLowerCase()
                  .startsWith(searchQuery.trim().toLowerCase())
              )
              .map((name, index) => {
                return (
                  <li className="row align-items-center" key={index}>
                    <div className="col-10">{name.nameDisplay}</div>
                    <div className="col-2 cursorPoint">
                      <BsFillArrowRightCircleFill
                        className="svgIcon"
                        title={localization.moveAttributeRight}
                        id="moveRightTest"
                        size={22}
                        onClick={() => {
                          handleSelectedAttribute(name, index);
                        }}
                      />
                    </div>
                  </li>
                );
              })}
          </ul>
        </div>
      </div>
    </>
  );
};

export default AllAttributePanel;
